<template>
  <div class="lean-batch-publish lean-batch-publish__container">
    <v-btn :disabled="!selectedRecordList.length" @click="publishAllSelected()" outlined>
      Publish
      <v-progress-circular v-if="waiting" indeterminate color="white"></v-progress-circular>
    </v-btn>
    <v-dialog v-model="showProgressDialog" persistent width="300">
      <v-card>
        <v-toolbar color="blue-grey darken-1" dark flat>
          <v-toolbar-title>{{ $t('publisher.headline') }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-5">
          <div class="pb-5">
            <div v-for="(path, index) of toPublishPaths" :key="index" class="mt-2">
              <div>
                {{ $store.state.sdk.getSlugFromPath(path.path) }}
              </div>
              <v-progress-linear
                stream
                background-color="blue-grey lighten-3"
                color="blue-grey"
                :value="toBeCheckedPaths.length === 0 || toBeCheckedPaths.includes(path.path) ? progress : 100"
                buffer-value="0"
                height="10"
                class="mt-2"
              />
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import publishMixin from '@/mixins/LeanPublish';

export default {
  name: 'LeanBatchPublish',
  mixins: [publishMixin],
  props: {
    datatype: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState('SelectedRecordListStore', { selectedRecordList: 'list' })
  },
  async mounted() {},
  methods: {
    publishAllSelected() {
      this.publishByPaths(this.selectedRecordList.map((slug) => `data/${this.datatype}/${slug}/${this.language}`));
    }
  }
};
</script>

<style scoped></style>
